export const sources={};export const img={src:"__VITE_ASSET__xUDJ5m8y__",w:36,h:36};export default{sources:sources,img:img};